import { render, staticRenderFns } from "./ConfigTabAssignments.vue?vue&type=template&id=9464219a"
import script from "./ConfigTabAssignments.vue?vue&type=script&lang=js"
export * from "./ConfigTabAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports